import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { FNOLCRIncidentDetailsPage } from 'wnice-capability-fnol-cr-react';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';

function FNOLIMIncidentsPage(props) {
    return <FNOLCRIncidentDetailsPage {...props} />;
}

FNOLIMIncidentsPage.propTypes = wizardProps;
FNOLIMIncidentsPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
};
export default withRouter(withAuthenticationContext(FNOLIMIncidentsPage));
